import React, { forwardRef, JSX} from 'react';
import { mergeClassAttributes } from '../../helpers/classes';

export type InputProps = {
  cn?: string;
  onEnter?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  ref?: React.Ref<HTMLInputElement>;
  'data-testid'?: string;
} & React.DetailedHTMLProps<
  Omit<React.InputHTMLAttributes<HTMLInputElement>, 'ref'>,
  HTMLInputElement
>;

const classes = [
  'rounded',
  'p-[0.9em]',
  'bg-gray-200',
  'dark:bg-gray-800',
  'border-transparent',
  'text-slate-800',
  'dark:text-slate-100',
  'w-full',
];

/**
 * Input component.
 */
export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ onEnter, onKeyDown, ...props }, ref): JSX.Element => (
    <input
      {...props}
      className={mergeClassAttributes(props, classes)}
      ref={ref}
      onKeyDown={(e) => {
        onKeyDown?.(e);
        if (e.key === 'Enter') {
          onEnter?.(e);
        }
      }}
    />
  ),
);

Input.displayName = 'Input';
